export const RULES = {
    root: 'rules-root',
    addButton: 'rules-add',
    saveButton: 'rules-save',
    nameInput: 'rules-name',
    scopeSelect: 'rules-scope',
    scopeMemberSelect: 'rules-scope-member',
    scopeHouseholdSelect: 'rules-scope-household',
    statusToggle: 'rules-status-toggle',
    delete: 'rules-delete',
    // conditions
    addCondition: 'rules-add-condition',
    condKind: 'rules-cond-kind',
    condMeasure: 'rules-cond-measure',
    condAspect: 'rules-cond-aspect',
    condOp: 'rules-cond-op',
    condValue: 'rules-cond-value',
    // actions
    addAction: 'rules-add-action',
    actionKind: 'rules-action-kind',
    heroMessage: 'rules-hero-message',
    heroStyle: 'rules-hero-style',
    heroExpires: 'rules-hero-expires',
    todoTitle: 'rules-todo-title',
    todoDue: 'rules-todo-due',
    attnNote: 'rules-attn-note',
    sendSurvey: 'rules-send-survey',
    // list
    row: 'rules-row',
    tryItToggle: 'rules-try-toggle',
};

export const HERO = {
    banner: 'hero-card-banner',
    manualAdd: 'hero-card-add',
    manualMessage: 'hero-card-message-input',
    manualStyle: 'hero-card-style',
    manualExpires: 'hero-card-expires',
    manualSubmit: 'hero-card-submit',
    manualDelete: 'hero-card-delete',
    history: 'hero-card-history-row',
};

export const WAITLIST = {
    email: 'waitlist-email',
    submit: 'waitlist-submit',
    success: 'waitlist-success',
};
